import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=5746986e&"
import script from "./Project.ts?vue&type=script&lang=js&"
export * from "./Project.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports